export const API = {
  // BASE_URL: "http://localhost:8004/mj4kerala-server/",
  BASE_URL: "https://mj4kerala-server.mj4p.com/mj4kerala-server/",

  ADMIN_LOGIN: "admin/adminlogin",
  CLIENT_LOGIN: "clientData/clientlogin",
  AWS_KEY: "aws/credentials",
  //admin
  UPDATE_ADMIN: "admin/updateadmin/",
  PASSWORD_UPDATE_ADMIN: "admin/update-password",
  FIND_ONE_ADMIN: "admin/find_oneadmin/",
  COUNT_ALL_DATA: "admin/countdata",

  // banner management
  BANNER_MANAGEMENT: "banner/listingbanner",
  CREATE_BANNER: "banner/createbanner",
  DELETE_BANNER: "banner/deletebanner/",
  UPDATE_BANNER: "banner/updatebanner/",
  GET_ONE_BANNER: "banner/find_onebanner/",

  // about us management
  ABOUTUS_MANAGEMENT: "about/listingabout",
  CREATE_ABOUTUS: "about/createabout",
  UPDATE_ABOUTUS: "about/updateabout/",
  GET_ONE_ABOUTUS: "about/find_oneabout/",
  DELETE_ONE_ABOUTUS: "about/deleteabout/",

  // core values management
  CREATE_CORE_VALUES: "coreValues/createcoreValues",
  CORE_VALUES: "coreValues/listingcoreValues",
  UPDATE_CORE_VALUES: "coreValues/updatecoreValues/",
  GET_ONE_CORE_VALUES: "coreValues/find_onecoreValues/",
  DELETE_ONE_CORE_VALUES: "coreValues/deletecoreValues/",

  //reviews management
  LIST_REVIEWS: "review/reviewdatapage",
  DELETE_REVIEWS: "review/deletereview/",
  FILTER_REVIEWS: "review/filterReview",
  CREATE_REVIEWS: "review/createreview",

  //opening hours management
  OPENING_HOURS_GET: "openingHours/listingOpeningHours",
  CREATE_OPENING_HOURS: "openingHours/createOpeningHours",
  DELETE_OPENING_HOURS: "openingHours/deleteOpeningHours/",
  FIND_ONE_OPENING_HOURS: "openingHours/find_oneOpeningHours/",
  UPDATE_OPENING_HOURS: "openingHours/updateOpeningHours/",

  //contact information adding
  CREATE_CONTACT_INFORMATION: "contactInformation/createcontactInformation",
  LIST_CONTACT_INFORMATION: "contactInformation/listingcontactInformation",
  EDIT_CONTACT_INFORMATION: "contactInformation/updatecontactInformation/",
  FIND_ONE_CONTACT_INFORMATION:
    "contactInformation/find_onecontactInformation/",

  //category management
  CREATE_CATEGORY: "category/createCategory",
  LISTING_CATEGORY: "category/categorypage",
  DELETE_CATEGORY: "category/deleteCategory/",
  FIND_ONE_CATEGORY: "category/find_oneCategory/",
  UPDATE_CATEGORY: "category/updateCategory/",
  LISTING_GET_CATEGORY: "category/listingCategory",
  FILTER_CATEGORY: "category/filterCategory",

  //subcategory
  CREATE_SUBCATEGORY: "subcategory/createSubCategory",
  LISTING_GET_SUBCATEGORY: "subcategory/listingSubCategory",
  LISTING_SUBCATEGORY: "subcategory/Subcategorypage",
  DELETE_SUBCATEGORY: "subcategory/deleteSubCategory/",
  UPDATE_SUBCATEGORY: "subcategory/updateSubCategory/",
  FIND_ONE_SUBCATEGORY: "subcategory/find_oneSubCategory/",
  FILTER_SUBCATEGORY: "subcategory/filterSubCategory",

  //product management
  CREATE_PRODUCT: "product/createproduct",
  LIST_PRODUCT: "product/productpage",
  DELETE_PRODUCT: "product/deleteproduct/",
  GET_ONE_PRODUCT: "product/find_oneproduct/",
  UPDATE_PRODUCT: "product/updateproduct/",
  PRODUCT_GET_LISTING: "product/listingproduct",
  PRODUCT_FILTER: "product/filterProduct",

  //booking data managemnet
  LISTING_BOOKING_DATA: "bookingData/bookingdata",
  DELETE_BOOKING_DATA: "bookingData/deletebookingData/",
  UPDATE_BOOKING_STATUS: "bookingData/updatebookingData/",
  FILTER_BOOKING_DATA: "bookingData/filterbookingdata",
  CREATE_BOOKING_DATA: "bookingData/createbookingData",
  FILTERYEAR_BOOKING_DATA: "bookingData/filter",

  // client page management
  LISTING_CLIENT_DATA: "clientData/clientdatapage",
  REGISTER_CLIENT_DATA: "clientData/createclientData", //create client detials
  UNBLOCK_CLIENT_DATA: "clientData/clientunblock/",
  BLOCK_CLIENT_DATA: "clientData/clientblock/",
  FIND_ONE_CLIENT_DATA: "clientData/find_oneclientData/",
  FILTER_CLIENT_DATA: "clientData/filterClientdata",
  GET_LISTING_CLIENT_DATA: "clientData/listingclientData",
  UPDATE_CLIENT_DATA: "clientData/updateclientData/",
  UPDATE_CLIENT_PASSWORD: "clientData/update-password",

  // contact messages from website
  CREATE_CONTACT_MESSAGE: "contactUs/createContactUs",
  DELETE_CONTACT_MESSAGE: "contactUs/deleteContactUsDto/",
  LIST_CONTACT_MESSAGE: "contactUs/contactUs",

  //offer table
  CREATE_OFFER_PRODUCT: "offer/createoffer",
  LIST_OFFER_PRODUCT: "offer/listingoffer",
  ACTIVE_OFFER_PRODUCT: "offer/active",
  DELETE_OFFER_PRODUCT: "offer/deleteoffer/",
  UPDATE_OFFER_PRODUCT: "offer/updateoffer/",
  FIND_ONE_OFFER_PRODUCT: "offer/find_oneOffer/",
  LISTOFFER_CLIENTID: "offer/offerlisting",
  LISTOFFER_ACTIVE_CLIENTID: "offer/activeclient/",
  LISTOFFER_ACTIVE_PRODUCTID: "offer/activeproduct/",

  // video management
  GET_ONE_VIDEO_MANAGEMENT: "VideoManagement/find_oneVideoManagement/",
  CREATE_VIDEO_MANAGEMENT: "VideoManagement/createVideoManagement",
  LIST_VIDEO_MANAGEMENT: "VideoManagement/listingVideoManagement",
  DELETE_VIDEO_MANAGEMENT: "VideoManagement/deleteVideoManagement/",
  UPDATE_VIDEO_MANAGEMENT: "VideoManagement/updateVideoManagement/",

  //engagement button management
  CREATE_ENGAGEMENT_BUTTON: "engagementButtons/createEngagementButtons",
  FIND_ONE_ENGAGEMENT_BUTTON: "engagementButtons/find_oneEngagementButtons/",

  // cart management
  CREATE_CART: "cart",
  ADD_TO_CART: "cart-items/add",
  LISTING_CART_DATA: "cart-items/",
  DELETE_CART_DATA: "cart-items/",
  UPDATE_CART_ITEM: "cart-items/update-quantity/",
  GET_ALL_CARTS: "cart",

  // product varient 
  CREATE_PRODUCT_VARIANT: "product-variant/createVariant",
  GET_BY_PRODUCTID_VARIANT: "product-variant/",
  UPDATE_PRODUCT_VARIANT: "product-variant/updateByProduct/",
  DELETE_PRODUCT_VARIANT: "product-variant/"
};
